



















































import {Component, Mixins} from 'vue-property-decorator';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import {ItemAuditTrailDialogRequest} from '@/model/CommonModel';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DataTable from '@/components/table/DataTable.vue';
import StringUtils from '@/utils/StringUtils';

@Component({
    mixins: [DialogEventsMixin],
    components: {
        CommonPaginatedTable,
        CommonPromptDialog,
        CommonButton,
        DataTable
    }
})
export default class ItemAuditTrailDialog extends Mixins<DialogEventsMixin>(DialogEventsMixin) {
    private dialogVisible = false;
    // ItemAuditTrail Dialog에 존재하는 모든 컬럼에 대한 너비 정의
    private columnWidths: string[] = ['50px', '200px', '300px', '200px', '200px', '200px'];
    // 한 Item 컬럼에 2가지 Audit 데이터를 보여야 할 경우, value의 구분자에 대해 정의
    private separator: string = '-';
    // editor text의 경우, v-html로 바인딩을 하기 위한 변수
    private isHTML: boolean = false;
    
    /*
     AuditTrail에 표기 될 Item에 대한 컬럼 정의
     아래와 같은 Item audit 데이터에 대해 Rendering 할 경우
        [{
            "no":null,
            "itemId":"SPN_NAME",
            "itemLabel":"Sponsor",
            "value":"20200831stg",
            "reason":"Initial Data",
            "time":"2020-08-31 14:58:17+09:00",
            "userId":"jepark@crscube.co.kr"}],"itemId":"SPN_NAME"
            }
            ...
        ]
        
       AuditTrail에 표기 할 Item은 SPN)NAME(Sponsor) 이므로 아래와 같이 요청을 넘기면 된다.
       itemColumns: [{columnId: 'value', columnName: 'Sponsor'}],
     */
    private itemColumns: any = [];
    private width: string = '1200px';
    private auditTrails: any = [];
    
    get isVisible() {
        return this.dialogVisible;
    }
    
    set isVisible(param) {
        this.dialogVisible = false;
    }

    /*
    한 Item 컬럼에 2가지 Audit 데이터를 보여야 할 경우,
    (예를들어, Search Item의 Condition이 Range인 경우
     Audit Trail Value 컬럼에 audit['value'] + 구분자 + audit['valueMax']을 보여야 함)

    itemColumns: [{columnId: 'value', additionalColumnId: 'valueMax', columnName: 'Direct Input'}]
    와 같이 요청을 넘기면 된다. 
    */
    get hasValueAdditionalColumnId() {
        return (additionalColumnValue: string) => {
            return StringUtils.hasValue(additionalColumnValue);
        };
    }

    public mounted() {
        this.$modal
            .getEventBus()
            .$on('showItemAuditTrailDialog', (params: ItemAuditTrailDialogRequest) => {
                this.auditTrails = params.auditTrailList;
                this.itemColumns = params.itemColumns;
                this.columnWidths = params.columnWidths ? params.columnWidths : this.columnWidths;
                this.width = params.width ? params.width : this.width;
                this.separator = params.separator ? params.separator : this.separator;
                this.isHTML = params.isHTML ? params.isHTML : this.isHTML;

                this.show();
            });

        this.$modal.getEventBus().$on('hideItemAuditTrailDialog', () => this.hide());
    }

    public show() {
        this.dialogVisible = true;
    }

    public hide() {
        this.dialogVisible = false;
    }

    public afterClosed() {
        this.auditTrails = [];
        this.itemColumns = [];
    }

    public destroyed() {
        this.$modal.getEventBus().$off('showItemAuditTrailDialog');
        this.$modal.getEventBus().$off('hideItemAuditTrailDialog');
    }
}
